import { ICreatePortionContext } from './createPortionContext';

export enum CreatePortionActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	CHANGE_NAME_OF_PORTION = 'CHANGE_NAME_OF_PORTION',
	CHANGE_PRICE = 'CHANGE_PRICE',
	CHANGE_PRICE_STRATEGY = 'CHANGE_PRICE_STRATEGY',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	TOGGLE_IS_PROTECT_FROM_SYNC = 'TOGGLE_IS_PROTECT_FROM_SYNC',
	TOGGLE_IS_DISABLED = 'TOGGLE_IS_DISABLED',
	// SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetInitialFormData {
	type: CreatePortionActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		fetchedCustomers: ICreatePortionContext['fetchedCustomers'];
		IDSelectedCustomer: ICreatePortionContext['IDSelectedCustomer'];
		fetchedRestaurants: ICreatePortionContext['fetchedRestaurants'];
		IDSelectedRestaurant: ICreatePortionContext['IDSelectedRestaurant'];
		nameOfDish: ICreatePortionContext['nameOfDish'];
		dishId: ICreatePortionContext['dishId'];
		isCreatedOnPos: ICreatePortionContext['isCreatedOnPos'];
		defaultCustomerLanguage: ICreatePortionContext['defaultCustomerLanguage'];
		translations: ICreatePortionContext['translations'];
	};
}

interface IChangeNameOfPortion {
	type: CreatePortionActionTypes.CHANGE_NAME_OF_PORTION;
	payload: {
		nameOfPortion: ICreatePortionContext['nameOfPortion'];
	};
}

interface IChangePrice {
	type: CreatePortionActionTypes.CHANGE_PRICE;
	payload: {
		price: ICreatePortionContext['price'];
	};
}

interface IChangePriceStrategy {
	type: CreatePortionActionTypes.CHANGE_PRICE_STRATEGY;
	payload: {
		priceStrategy: ICreatePortionContext['priceStrategy'];
	};
}

interface IChangeExternalId {
	type: CreatePortionActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: ICreatePortionContext['externalId'];
	};
}

interface IToggleIsTaxPercentProtectedFromSync {
	type: CreatePortionActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC;
}

interface IToggleIsDisabled {
	type: CreatePortionActionTypes.TOGGLE_IS_DISABLED;
}

// interface ISetFetchedTranslation {
// 	type: CreatePortionActionTypes.SET_FETCHED_TRANSLATIONS;
// 	payload: {
// 		translations: ICreatePortionContext['translations'];
// 		defaultCustomerLanguage: ICreatePortionContext['defaultCustomerLanguage'];
// 	};
// }

interface ISetTranslationTab {
	type: CreatePortionActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreatePortionContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreatePortionActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreatePortionContext['translations'];
	};
}

interface IToggleApplyToOne {
	type: CreatePortionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: CreatePortionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: ICreatePortionContext['selectedAdditionalRestaurants'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreatePortionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreatePortionContext['typeOfModalWindow'];
	};
}

export type TCreatePortionAction =
	| ISetInitialFormData
	| IChangeNameOfPortion
	| IChangePrice
	| IChangePriceStrategy
	| IChangeExternalId
	| IToggleIsTaxPercentProtectedFromSync
	| IToggleIsDisabled
	// | ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeTypeOfModalWindow;
